import styled, {css, keyframes} from 'styled-components';

export const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

export const fadeOut = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;

export const slideIn = keyframes`
    from {
        transform: translateY(-20px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
`;

export const slideOut = keyframes`
    from {
        transform: translateY(0);
        opacity: 1;
    }
    to {
        transform: translateY(-20px);
        opacity: 0;
    }
`;

export const scaleIn = keyframes`
    from {
        transform: scale(0.9);
        opacity: 0;
    }
    to {
        transform: scale(1);
        opacity: 1;
    }
`;

export const scaleOut = keyframes`
    from {
        transform: scale(1);
        opacity: 1;
    }
    to {
        transform: scale(0.9);
        opacity: 0;
    }
`;

export const BackdropContainer = styled.div<{
    $isOpen: boolean;
    $animation: 'fade' | 'slide' | 'scale' | 'none';
}>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.5);

    ${({$isOpen, $animation}) => {
        if ($animation === 'none') {
            return $isOpen ? '' : 'display: none;';
        }

        return css`
            animation: ${$isOpen ? fadeIn : fadeOut} 0.3s ease-in-out;
            ${!$isOpen &&
            css`
                pointer-events: none;
                visibility: hidden;
            `}
        `;
    }}
`;

export const ModalContainer = styled.div<{
    $size: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'full';
    $isOpen: boolean;
    $animation: 'fade' | 'slide' | 'scale' | 'none';
}>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 8px;
    box-shadow:
        0 20px 25px -5px rgba(0, 0, 0, 0.1),
        0 10px 10px -5px rgba(0, 0, 0, 0.04);

    ${({$size}) => {
        const sizeMap = {
            sm: 'max-width: 20vw;',
            md: 'max-width: 40vw;',
            lg: 'max-width: 50vw;',
            xl: 'max-width: 60vw;',
            xxl: 'max-width: 80vw;',
            full: 'max-width: calc(100% - 32px); margin: 0 16px;',
        };
        return sizeMap[$size];
    }}

    ${({$isOpen, $animation}) => {
        if ($animation === 'none') return '';

        const animationMap = {
            fade: $isOpen ? fadeIn : fadeOut,
            slide: $isOpen ? slideIn : slideOut,
            scale: $isOpen ? scaleIn : scaleOut,
        };

        return css`
            animation: ${animationMap[$animation]} 0.3s ease-in-out;
        `;
    }}
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 10;
    padding: 4px;
    color: #9ca3af;
    background: none;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    transition: color 0.2s ease-in-out;

    &:hover {
        color: #4b5563;
    }

    &:focus {
        outline: none;
        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
    }
`;

export const CloseIcon = styled.svg`
    width: 24px;
    height: 24px;
`;
